<template>
  <div id="page">
    <div id="breadcrumb-wrapper">
      <div class="container">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item" v-for="(breadcrumb, key) in breadcrumbs" v-bind:key="key" v-bind:class="{active: key === (breadcrumbs.length - 1)}">
              <router-link :to="{ name: breadcrumb.path }" v-if="key !== (breadcrumbs.length - 1)">{{ breadcrumb.name }}</router-link>
              <span v-if="key === (breadcrumbs.length - 1)">{{ breadcrumb.name }}</span>
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="container">
      <div class="row mt-5">
        <div class="col-12">
          <img src="../assets/img/diamondpruksa.svg" alt="" class="manu-logo d-block img m-auto">
        </div>
        <div class="col-12 col-md-8 offset-md-2 mt-4">
          <p class="text-center" v-html="manuDetail.story"></p>
        </div>
      </div>
    </div>

    <div class="container bg-white mt-4 box-shadow manu-product">
      <div class="row pt-4 mb-4">
        <div class="col-12">
          <h1 class="text-center">{{ title.ourProduct }}</h1>
        </div>
      </div>
      <div class="row pb-5">
        <div class="col-12 pl-5 pr-5 category-swiper">
          <swiper :options="swiperOption">
            <swiper-slide v-for="(product, key) in manuProduct" v-bind:key="key">
              <img v-bind:src="media_path + product.path + product.img_sm" v-bind:alt="product.product_name" class="img-fluid d-block">
              <p class="text-center mt-3">{{ product.product_name }}</p>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </div>
      </div>
    </div>

    <div class="manu-bg">
      <div class="container mt-5 pt-5">
        <h1 class="text-center text-white">{{ title.aboutManu }}</h1>
        <div class="row mt-5 justify-content-center">
          <div class="col-10 pb-5">
            <div class="row pb-5">
              <div class="col-12 col-lg-6 mb-4 mb-lg-0">
                <div class="row">
                  <div class="col-5 col-md-3 col-lg-12">
                    <img src="../assets/img/establish.png" class="d-block m-auto img-fluid">
                  </div>
                  <div class="col-7 col-md-9 col-lg-12">
                    <p class="m-auto text-left text-lg-center text-white p-0 pt-lg-4">{{ title.about.section1 }}</p>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-6 mb-4 mb-lg-0">
                <div class="row">
                  <div class="col-5 col-md-3 col-lg-12">
                    <img src="../assets/img/factory.png" class="d-block m-auto img-fluid">
                  </div>
                  <div class="col-7 col-md-9 col-lg-12">
                    <p class="m-auto text-left text-lg-center text-white p-0 pt-lg-4">{{ title.about.section2 }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="manu-contact">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-5 col-lg-6 d-flex align-items-center">
            <div class="manu-map-container">
              <div id="map"></div>
            </div>
          </div>
          <div class="col-12 col-md-7 col-lg-6 p-4 p-lg-5">
            <h1 class="text-white pl-4 mb-4">{{ title.contact }}</h1>
            <div class="row contact-info mb-2" v-if="manuDetail.address">
              <div class="col-2 contact-icon text-right"><i class="icon-home"></i></div>
              <div class="col-10">{{ manuDetail.address }}</div>
            </div>
            <div class="row contact-info mb-4" v-if="manuDetail.fax">
              <div class="col-2 contact-icon text-right"><i class="icon-fax"></i></div>
              <div class="col-10">{{ manuDetail.fax }}</div>
            </div>
            <div class="row contact-info mb-4" v-if="manuDetail.tel">
              <div class="col-2 contact-icon text-right"><i class="icon-phone"></i></div>
              <div class="col-10"><a v-bind:href="'tel:' + manuDetail.tel">{{ manuDetail.tel }}</a></div>
            </div>
            <div class="row contact-info mb-4" v-if="manuDetail.email">
              <div class="col-2 contact-icon text-right"><i class="icon-envelope"></i></div>
              <div class="col-10"><a v-bind:href="'mailto:' + manuDetail.email">{{ manuDetail.email }}</a></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import axios from 'axios'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'Manufacturer',
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      lang: this.$router.history.current.params.lang,
      manuDetail: [],
      manuProduct: [],
      breadcrumbs: [],
      title: {
        ourProduct: '',
        aboutManu: '',
        about: {
          section1: '',
          section2: '',
          section3: ''
        },
        contact: ''
      },
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 30,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 40
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10
          }
        }
      },
      media_path: process.env.MEDIA_PATH
    }
  },
  mounted () {
    // Load Manufacturer Detail
    this.getManuDetail()
    this.getManuProduct()

    // Lang
    if (this.lang === 'th') {
      document.title = 'บริษัทผู้ผลิต - เคฟู๊ด อิมปอร์ต เอ็กซ์ปอร์ต จำกัด'
      this.title = {
        ourProduct: 'ผลิตภัณฑ์ของเรา',
        aboutManu: 'เกี่ยวกับไดมอนด์ พฤกษา',
        about: {
          section1: 'ไดมอนด์พฤกษาผลิตสินค้าสมุนไพร ภายใต้คุณธรรมและศีลธรรมเพื่อรักษาไว้ซึ่งศาสตร์แห่งสมุนไพรดั้งเดิมของไทย ภายใต้แนวทาง เทพ พรหม และครูบาอาจารย์ที่ประสิทธิ์ประสาทวิชาแพทย์แผนไทย ทั้งในอดีตและปัจจุบัน เพื่อนำประโยชน์ของสมุนไพรไทยไปเสริมสร้างสุขภาพที่ดีสู่ตลาดโลก',
          section2: 'ไดมอนด์พฤกษาผลิตสินค้าภายใต้มาตรฐานทุกขั้นตอน ไดมอนด์พฤกษาได้ผ่านการอนุมัติเผื่อผลิต ผลิตภัณฑ์สมุนไพรคุณภาพในทุกสินค้าชั้นนำเกรดเอ ที่ออกสู่การจัดจำหน่ายทั้งในและต่างประเทศ ซึ่งเป็นที่ไว้วางใจจากลุ่มสินค้าเกรดเอ ให้รองรับการผลิตตามมาตรฐานสากล จนเป็นที่ยอมรับและได้รับการคัดสรรจากหลากหลายผลิตภัณฑ์ เพื่อผลิตสินค้าเปี่ยมด้วยคุณภาพเสมอมา'
        },
        contact: 'ติดต่อเรา'
      }
    } else {
      document.title = 'Manufacturer - K Food Import Export Co., Ltd.'
      this.title = {
        ourProduct: 'Our Products',
        aboutManu: 'About Diamond Pruksa',
        about: {
          section1: 'Diamond Pruksa manufacture the herbal product. Under the ethics and morality to preserve the traditional Herbology of Thailand and under guidance of Thep Prom and the teacher of Thai traditional medicine both past and present to bring the benefits of Thai herb to promote for the healthy life to the world market.',
          section2: 'Diamond Pruksa manufacture the product under the standard in every steps Diamond Pruksa has been approved for manufacturing the high quality herbal products distributed in both domestic and international. With the trustworthy of product support with the production of the international standard always bring us the acceptance from many brands now.'
        },
        contact: 'Contact Us'
      }
    }

    this.getBreadcrumb()
  },
  methods: {
    getManuDetail () {
      let self = this
      axios.get(process.env.API_PATH + '/getManufacturer', {
        params: {
          lang: self.lang
        }
      }).then((response) => {
        self.manuDetail = response.data.result
        if (self.manuDetail.lat && self.manuDetail.lng) {
          self.getMap(self.manuDetail.lat, self.manuDetail.lng, self.manuDetail.address)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    getManuProduct () {
      let self = this
      axios.get(process.env.API_PATH + '/getManufacturerProduct', {
        params: {
          lang: self.lang
        }
      }).then((response) => {
        self.manuProduct = response.data.result
      }).catch((error) => {
        console.log(error)
      })
    },
    getMap (dataLat, dataLng, dataDetail) {
      const element = document.getElementById('map')
      const center = {lat: parseFloat(dataLat), lng: parseFloat(dataLng)}
      const options = {
        zoom: 16,
        center: center
      }
      const map = new google.maps.Map(element, options)

      const marker = new google.maps.Marker({
        position: center,
        map: map
      })

      const contentString = '<p>' + dataDetail + '</p>'

      // eslint-disable-next-line no-undef
      const infowindow = new google.maps.InfoWindow({
        content: contentString,
        maxWidth: 300
      })

      marker.addListener('click', function () {
        infowindow.open(map, marker)
      })
    },
    getBreadcrumb () {
      if (this.lang === 'th') {
        this.breadcrumbs = [
          {
            name: 'หน้าแรก',
            path: 'Home'
          },
          {
            name: 'บริษัทผู้ผลิต'
          }
        ]
      } else {
        this.breadcrumbs = [
          {
            name: 'Home',
            path: 'Home'
          },
          {
            name: 'Manufacturer'
          }
        ]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Manufacturer.vue